import ConfirmChequePopup from "./ConfirmChequePopup";

export default ConfirmChequePopup;
